import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';
import { uploadTextStepImage } from './uploadTextStepImage';
import { CourseStep } from '../models/course';

export const createTextStep = (
  courseId: string,
  stepName: string,
  stepDescription: string,
  order: number,
  initiatingUserId: string
): Promise<CourseStep> => {
  return uploadTextStepImage(stepDescription).then(updatedDescription => {
    const taskId = uuid.generate();
    return submitCommand(
      courseId,
      {
        id: courseId,
        taskId: taskId,
        taskName: stepName,
        taskDescription: updatedDescription,
        order: order,
        response: '',
        initiatingUserId: initiatingUserId,
      },
      'AddTextTask',
      'TextTaskIsAddedToTasklist',
      'TaskListError'
    ).then(() => ({
      _id: { id: taskId },
      _type: 'Text',
      taskName: stepName,
      taskDescription: updatedDescription,
      order,
      response: '',
    }));
  });
};
